import { _ as t } from "../internals/export.js";
import { f as r } from "../internals/function-call.js";
t({
  target: "URL",
  proto: !0,
  enumerable: !0
}, {
  toJSON: function toJSON() {
    return r(URL.prototype.toString, this);
  }
});